import { c as _c } from "react/compiler-runtime";
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
import { RadioInput } from '@/components/inputs';
import { useCustomInput } from '../utils/useCustomInput';
import { mergeClasses } from '@/utils/style';
export function RadioselectInput(props) {
  const $ = _c(17);
  const submitError = !props.meta.dirtySinceLastSubmit ? props.meta.submitError : undefined;
  const errorMessage = props.meta.error || submitError;
  const hasError = !!errorMessage && (props.meta.touched || props.meta.submitFailed);
  const errorId = `${props.input.name}-error`;
  const hasTextInput = props.hasCustomInput;
  const choices = props.options.map(_temp);
  const {
    handleCustomInputChange
  } = useCustomInput({
    initInputValue: props.input.value ? [props.input.value] : undefined,
    inputOnChange: props.input.onChange,
    choices
  });
  const t0 = props.variant === "onRow" ? "grid md:grid-cols-3" : "flex flex-col";
  let t1;
  if ($[0] !== t0) {
    t1 = mergeClasses("relative gap-4", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = hasError ? errorId : undefined;
  const t3 = hasError ? "true" : "false";
  let t4;
  if ($[2] !== handleCustomInputChange || $[3] !== hasTextInput || $[4] !== props.input || $[5] !== props.options.length) {
    t4 = (choice_0, index) => {
      const isLast = index === (props.options?.length || 0) - 1;
      return <label className="block" key={index}><span><RadioInput label={choice_0.label} input={{
            name: props.input.name,
            onChange: event => {
              props.input.onChange(event.target.value);
            },
            checked: props.input.value?.includes(choice_0.value),
            value: choice_0.value
          }} meta={{}} />{isLast && hasTextInput && <input className="input mt-4" type="text" onChange={e => handleCustomInputChange(e.target.value)} />}</span></label>;
    };
    $[2] = handleCustomInputChange;
    $[3] = hasTextInput;
    $[4] = props.input;
    $[5] = props.options.length;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = choices.map(t4);
  let t6;
  if ($[7] !== errorId || $[8] !== errorMessage || $[9] !== hasError) {
    t6 = hasError && <ErrorMessage error={errorMessage} id={errorId} />;
    $[7] = errorId;
    $[8] = errorMessage;
    $[9] = hasError;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className={t1} aria-describedby={t2} aria-invalid={t3}>{t5}{t6}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
function _temp(choice) {
  return typeof choice === "string" ? {
    label: choice,
    value: choice
  } : choice;
}